<template>
  <v-tooltip top color="transparent" max-width="480">
    <template v-slot:activator="{ on, attrs }">
      <span class="sv-tip" v-bind="attrs" v-on="on"><slot>{{ label }}</slot></span>
    </template>
    <div class="white-bg-tooltip small-tooltip p-3">
      <span class="tooltip-heading">{{ heading || label }}</span><br /><br />
      <span class="tooltip-discription">
        <div v-for="(line, i) in lines" :key="i" class="sv-tip-line">
          <span v-if="line && line.chip" :class="chipClass(line.chip)">{{ line.chip.label }}</span>
          {{ lineText(line) }}
        </div>
      </span>
    </div>
  </v-tooltip>
</template>

<script>
/**
 * POP's white tooltip (v-tooltip, transparent, .white-bg-tooltip card) with a heading and one
 * paragraph per line. A line is a string, or { chip: { kind, value, label }, text } to start the
 * paragraph with a coloured label in the colours of the table: kind 'score' (value fail |
 * borderline | ok | empty), 'scenario' (A | B | C | D) or 'verdict' (healthy | poisoned).
 */
export default {
  name: 'SerpValidationTip',
  props: {
    label: { type: String, default: '' },
    heading: { type: String, default: '' },
    lines: { type: Array, default: () => [] },
  },
  methods: {
    chipClass (chip) {
      return ['sv-chip', 'sv-chip--' + chip.kind + '-' + chip.value]
    },
    lineText (line) {
      return typeof line === 'string' ? line : (line && line.text) || ''
    },
  },
}
</script>
